(() => {
  'use strict';

  const STORAGE_KEY = 'tvEditorialStickyDismissedV1';
  const widget = document.querySelector('[data-editorial-sticky-product-cta]');

  if (!widget || widget.dataset.initialized === 'true') return;
  widget.dataset.initialized = 'true';

  let dismissed = false;
  try {
    dismissed = sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    dismissed = false;
  }

  if (dismissed) return;

  const threshold = Number.parseFloat(widget.dataset.showAtProgress || '0.5');
  const dismissButton = widget.querySelector('[data-editorial-sticky-dismiss]');
  const destinationLink = widget.querySelector('[data-editorial-sticky-link]');
  let shown = false;
  let ticking = false;

  const track = (eventName) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      component: 'editorial_sticky_product_cta',
      page_type: widget.dataset.pageType || '',
      destination: destinationLink?.href || ''
    });
  };

  const pageProgress = () => {
    const root = document.documentElement;
    const scrollable = Math.max(root.scrollHeight - window.innerHeight, 1);
    return Math.min(Math.max(window.scrollY / scrollable, 0), 1);
  };

  const show = () => {
    if (shown) return;
    shown = true;
    widget.hidden = false;
    widget.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => widget.classList.add('is-visible'));
    track('editorial_sticky_cta_view');
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  };

  const checkProgress = () => {
    ticking = false;
    if (pageProgress() >= threshold) show();
  };

  const onScroll = () => {
    if (ticking || shown) return;
    ticking = true;
    window.requestAnimationFrame(checkProgress);
  };

  dismissButton?.addEventListener('click', () => {
    track('editorial_sticky_cta_dismiss');
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
    widget.classList.remove('is-visible');
    widget.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      widget.hidden = true;
    }, 200);
  });

  destinationLink?.addEventListener('click', () => {
    track('editorial_sticky_cta_click');
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  checkProgress();
})();
